<template>
	<div class="aboutUs">
		<!--头部banner-->
		<!-- <div class="banner">
      <div class="bannerTitle">关于我们</div>
      <div class="bannerzn">ABOUT US</div>
    </div> -->

		<!--主体-->
		<div class="main m-b-30">
			<div class="elbox">
				<el-row>
					<el-col :span="6">
						<div class="grid-content bg-purple">
							<div class="left">
								<div class="content">
									<div class="aboutus">关于我们</div>
									<ul class="aboutus_item">
										<li :class="{ clickli: currentName === index }" @click="clickItem(index)" v-for="(item, index) in aboutUsList" :key="index">{{ item.title }}</li>
									</ul>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="18">
						<div class="grid-content bg-purple-light">
							<div class="right">
								<div class="content">
									<div>{{ info.title }}</div>
									<div v-html="info.content" class="htmlContent"></div>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
// import Introduction from '@/Mock/AboutUs/Introduction.json'
// import yszc from '@/Mock/AboutUs/yszc.json'
// import lxwm from '@/Mock/AboutUs/lxwm.json'
// import sysmhmztk from '@/Mock/AboutUs/sysmhmztk.json'
// import jdrx from '@/Mock/AboutUs/jdrx.json'
import { mapGetters } from 'vuex'

export default {
	name: 'aboutUs',
	components: {},
	data() {
		return {
			aboutUsList: [],
			info: {},
			currentName: 0
		}
	},
	computed: {
		...mapGetters({
			address: 'getAddress',
			youbian: 'getYB',
			email: 'getEmail',
			phone: 'getPhone',
			name: 'getPlatformName'
		})
	},
	created() {
		this.getAboutUs()
	},
	mounted() {},
	watch: {
		// '$route.query.type': {
		//   handler(newValue) {
		//     this.currentName = newValue
		//     this.getAboutUs(this.currentName)
		//   }
		// }
	},
	methods: {
		//获取关于我们
		async getAboutUs(type) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.aboutUsListURl)
				if (res.code === 200) {
					this.aboutUsList = res.data
					this.info = this.aboutUsList[this.currentName]
				}
			} catch (e) {
				console.log(e)
			}
		},

		clickItem(e) {
			// this.$router.push({
			//   name: 'aboutUS',
			//   query: {
			//     type: currentName
			//   }
			// })
			this.currentName = e
			this.info = this.aboutUsList[this.currentName]
		}
	}
}
</script>

<style lang="scss" scoped>
$height: 1000px;
.aboutUs {
	.banner {
		width: 100%;
		min-width: 1200px;
		height: 25vh;
		background: url('~@/assets/imgs/AboutUs/contact_us1.png') no-repeat;
		background-size: 100% 100%;
		background-position: center;
		.bannerTitle {
			width: 80%;
			margin: 0 auto;
			padding-top: 3%;
			line-height: 60px;
			font-size: 28px;
			color: #f5f5f5;
		}
		.bannerzn {
			width: 80%;
			margin: 0 auto;
			line-height: 40px;
			font-size: 22px;
			color: #f5f5f5;
		}
	}

	.main {
		// margin-top: -50px;

		.elbox {
			margin: 0 auto;
			width: 100%;

			.left {
				width: 100%;
				padding: 0 0 0 50px;

				.content {
					width: 100%;
					height: $height;
					background: #fff;
					border: 1px solid #dde4ea;

					.aboutus {
						padding-left: 40px;
						height: 50px;
						line-height: 50px;
						font-size: 20px;
						font-weight: bold;
					}

					ul.aboutus_item {
						overflow: hidden;

						li {
							padding-left: 40px;
							height: 50px;
							line-height: 50px;
							cursor: pointer;
							font-size: 14px;
							position: relative;

							i {
								margin-right: 10px;
							}
						}

						li:hover,
						.clickli {
							color: #3867e9;
							background: #f5f7fe;
						}

						li.clickli::before {
							display: inline-block;
							content: '';
							width: 5px;
							height: 15px;
							background: #3867e9;
							position: absolute;
							top: 0;
							bottom: 0;
							margin: auto;
							left: 0;
						}
					}

					.imgBox {
						height: 210px;
						margin-top: 5px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
							transition: all 0.75s;
						}

						img:hover {
							transform: scale(1.1);
						}
					}

					ul.companyInfo {
						li {
							padding: 0 10px;
							margin: 12px 0;
						}
					}
				}
			}

			.right {
				width: 100%;
				padding: 0 50px 0 20px;

				.content {
					width: 100%;
					height: $height;
					background: #fff;
					margin: 0 auto;
					border: 1px solid #dde4ea;
					padding: 25px;
					overflow-y: auto;
					scrollbar-width: none; /* firefox */
					-ms-overflow-style: none; /* IE 10+ */

					&::-webkit-scrollbar {
						/* Chrome Safari */
						display: none;
					}

					div:nth-child(1) {
						text-align: center;
						font-size: 22px;
						font-weight: 400;
						margin-bottom: 30px;
					}
				}
			}
		}
	}
}
</style>

<style>
.htmlContent p img {
	width: 100%;
}
.htmlContent p {
	font-family: '宋体' !important;
	line-height: 30px;
	text-indent: 2rem;
}
.htmlContent p span {
	font-family: '宋体' !important;
	line-height: 30px;
	text-indent: 2rem;
}
</style>
